@if (activeNavIndex > -1 || shopNavActiveIndex > -1) {
  <div class="container-fluid blurred-background"></div>
}

<!-- Main navigation -->
<nav
  class="main-navigation"
  [ngClass]="{ scrolled: scrolledOnShopRelatedPage }"
  role="navigation"
  [attr.aria-label]="'common.menu' | cxTranslate"
  (mouseenter)="cancelCloseTimer()"
  (mouseleave)="onMouseLeave($event)"
>
  @if (scrolledOnShopRelatedPage) {
    <ul class="main-navigation-lvl-1">
      <ng-container *ngFor="let category of categoryTree; let i = index; trackBy: trackByCode">
        <li
          #navigationItem
          (mouseenter)="onHoverShopNavLink(i)"
          (mouseleave)="cancelShopNavTimer()"
          [attr.data-nav-index]="i"
        >
          <app-link
            [link]="category.url"
            [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i"
            (click)="closeNavigation()"
            (focused)="onMouseEnter(navigationItem, shopNodeIndex)"
            (keyup)="handleKeyDown($event, shopNodeIndex)"
            class="main-navigation-link main-navigation-link-lvl-1 mb-0"
            [ngClass]="{
              'active-item':
                shopNavActiveIndex > -1
                  ? hoveredItem && hoveredItem === navigationItem
                  : (currentPath && category.url.startsWith(currentPath)) ||
                    mainCategoryActiveIndex === i,
            }"
          >
            <span>{{ category.name }}</span>
          </app-link>
        </li>
      </ng-container>
    </ul>
  } @else {
    <ul class="main-navigation-lvl-1">
      <ng-container *ngFor="let navigationNode of navigationNodes; let i = index">
        <li
          #navigationItem
          *ngIf="navigationNode?.fields?.url"
          (mouseenter)="
            onMouseEnter(navigationItem, isShopNode(navigationNode) ? shopNodeIndex : i)
          "
          [attr.data-nav-index]="i"
        >
          <app-link
            [maskLink]="navigationNode?.fields?.maskLink"
            [link]="navigationNode?.fields?.url"
            [shopItem]="isShopNode(navigationNode)"
            [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i"
            (click)="clickNavigation($event, navigationNode)"
            (focused)="onMouseEnter(navigationItem, isShopNode(navigationNode) ? shopNodeIndex : i)"
            (keyup)="handleKeyDown($event, isShopNode(navigationNode) ? shopNodeIndex : i)"
            class="main-navigation-link main-navigation-link-lvl-1"
            [ngClass]="{
              'shop-item': isShopNode(navigationNode),
              'opened-shopnav':
                activeNavIndex === shopNodeIndex || (isShopRelatedPage && activeNavIndex === -1),
              'active-item': hoveredItem
                ? hoveredItem === navigationItem
                : defaultActiveIndex === i,
            }"
            [padding]="true"
          >
            <span>{{ navigationNode?.fields?.name }}</span>
          </app-link>
        </li>
      </ng-container>
    </ul>
  }
</nav>

<!-- Main flyout -->
<div class="flyout-portal" *ngIf="activeNavIndex > -1">
  <ng-container *ngFor="let navigationNode of navigationNodes; let i = index">
    <div
      #flyoutMenu
      class="main-navigation-lvl-2 main-flyout"
      *ngIf="navigationNode?.fields?.url && activeNavIndex === i"
      [attr.data-nav-index]="i"
      [class.active]="activeNavIndex === i"
      (keyup)="handleFlyoutKeyDown($event, i)"
      (mouseenter)="cancelCloseTimer()"
      (mouseleave)="onMouseLeave($event)"
      [style.max-height.px]="availableFlyoutHeight"
      tabindex="-1"
    >
      <div class="updated-nav-flyout-content">
        <div class="title">{{ navigationNode.fields?.name }}</div>

        <div class="updated-nav-flyout-list">
          <div class="d-flex flex-grow-1">
            <!-- Level 2 -->
            <ul class="nav-nodes-container lvl-0">
              <a
                [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 0 + '-' + i"
                (click)="closeNavigation()"
                class="show-all-link"
                [routerLink]="navigationNode.fields?.url"
              >
                {{ 'common.overviewPage' | cxTranslate }}
              </a>

              <li
                *ngFor="
                  let navigationNodeLvl2 of navigationNode?.fields?.childNavigationNodes;
                  let i2 = index
                "
                (mouseenter)="setActive(0, i2)"
                (mouseleave)="cancelHoverTimer()"
                [ngClass]="{
                  active: activePathByKeyboard.length
                    ? activePathByKeyboard[0] === i2
                    : hoveredActivePath[0] === i2 ||
                      (defaultActiveIndex === i && activePath[0] === i2),
                }"
              >
                <app-link
                  *ngIf="navigationNodeLvl2.fields?.visible"
                  [link]="navigationNodeLvl2.fields?.url"
                  [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i + '-' + i2"
                  (click)="closeNavigation()"
                  class="main-navigation-link main-navigation-link-lvl-3"
                >
                  <span>{{ navigationNodeLvl2?.fields?.name }}</span>

                  <div class="svg-placeholder"></div>

                  @if (navigationNodeLvl2?.fields?.childNavigationNodes?.length) {
                    <app-svg iconName="chevron-right" dimension="1.6rem"></app-svg>
                  }
                </app-link>
              </li>
            </ul>

            <!-- Level 3 -->
            <ul
              class="nav-nodes-container lvl-1"
              *ngIf="
                navigationNode?.fields?.childNavigationNodes[activePath[0]]?.fields
                  ?.childNavigationNodes &&
                (hoveredActivePath[0] !== undefined ||
                  (defaultActiveIndex === i && activePath[0] !== undefined))
              "
            >
              <a
                [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 0 + '-' + i"
                (click)="closeNavigation()"
                class="show-all-link"
                [routerLink]="
                  navigationNode?.fields?.childNavigationNodes[activePath[0]]?.fields?.url
                "
              >
                {{ navigationNode?.fields?.childNavigationNodes[activePath[0]]?.fields?.name }}
              </a>

              <li
                *ngFor="
                  let navigationNodeLvl3 of navigationNode?.fields?.childNavigationNodes[
                    activePath[0]
                  ]?.fields?.childNavigationNodes;
                  let i3 = index
                "
                (mouseenter)="setActive(1, i3)"
                (mouseleave)="cancelHoverTimer()"
                [ngClass]="{
                  active: activePathByKeyboard.length
                    ? activePathByKeyboard[1] === i3
                    : hoveredActivePath[1] === i3 ||
                      (defaultActiveIndex === i && activePath[1] === i3),
                }"
              >
                <app-link
                  *ngIf="navigationNodeLvl3.fields?.visible"
                  [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i + '-' + i3"
                  (click)="closeNavigation()"
                  class="main-navigation-link main-navigation-link-lvl-3"
                  [link]="navigationNodeLvl3?.fields?.url"
                >
                  <span>{{ navigationNodeLvl3?.fields?.name }}</span>
                </app-link>
              </li>
            </ul>
          </div>

          <ng-container
            *ngTemplateOutlet="nodeImage; context: { $implicit: navigationNode }"
          ></ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Shop navigation -->
@if (!scrolledOnShopRelatedPage) {
  <div
    class="flyout-portal"
    *ngIf="activeNavIndex === shopNodeIndex || (isShopRelatedPage && activeNavIndex === -1)"
  >
    <div
      #flyoutMenu
      class="main-navigation-lvl-2 shop-navigation"
      *ngIf="shopNode?.fields?.url"
      [attr.data-nav-index]="shopNodeIndex"
      [class.active]="true"
      (keydown)="handleKeyDown($event, shopNodeIndex)"
      (mouseenter)="cancelCloseTimer()"
      (mouseleave)="onMouseLeave($event)"
      tabindex="-1"
    >
      <ul class="main-navigation-lvl-2-list">
        <li
          #shopNavItem
          *ngFor="let category of categoryTree; let i2 = index; trackBy: trackByCode"
          (mouseenter)="onHoverShopNavLink(i2)"
          (mouseleave)="cancelShopNavTimer()"
        >
          <app-link
            #flyoutLink
            [link]="category.url"
            [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + shopNodeIndex + '-' + i2"
            (click)="closeNavigation()"
            class="main-navigation-link main-navigation-link-lvl-2"
            [ngClass]="{
              'active-item':
                shopNavActiveIndex > -1
                  ? shopNavActiveIndex === i2
                  : (currentPath && category.url.startsWith(currentPath)) ||
                    mainCategoryActiveIndex === i2,
            }"
          >
            <span>{{ category.name }}</span>
          </app-link>
        </li>
      </ul>
    </div>
  </div>
}

<!-- Shop flyout -->
<div
  class="flyout-portal"
  *ngIf="
    (activeNavIndex === shopNodeIndex || (isShopRelatedPage && activeNavIndex === -1)) &&
    shopNavActiveIndex > -1
  "
>
  <ng-container *ngFor="let category of categoryTree; let i = index; trackBy: trackByCode">
    <div
      #flyoutMenu
      class="main-navigation-lvl-2 updated-nav-flyout"
      [ngClass]="{ scrolled: scrolledOnShopRelatedPage }"
      [style.display]="shopNavActiveIndex === i ? null : 'none'"
      [attr.data-nav-index]="i"
      [class.active]="shopNavActiveIndex === i"
      (keydown)="handleFlyoutKeyDown($event, i)"
      (mouseenter)="cancelCloseTimer()"
      (mouseleave)="onMouseLeave($event)"
      [style.max-height.px]="availableFlyoutHeight"
      [style.--ul-max-height]="availableFlyoutHeight ? availableFlyoutHeight - 120 + 'px' : '400px'"
      tabindex="-1"
    >
      <div class="updated-nav-flyout-content">
        <div class="title">{{ category.name }}</div>

        <div class="updated-nav-flyout-list" [ngClass]="{ 'flex-column': onMobile }">
          <div class="d-flex flex-grow-1 gap-16">
            <!-- Prefixbox categories level 0 -->
            <ul class="nav-nodes-container lvl-0">
              <a
                [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 0 + '-' + i"
                (click)="closeNavigation()"
                class="show-all-link"
                [routerLink]="category.url"
              >
                {{ 'common.viewAll' | cxTranslate }}
              </a>

              <li
                *ngFor="
                  let subcategory of category.subcategories;
                  let i0 = index;
                  trackBy: trackByCode
                "
                (mouseenter)="setActive(0, i0)"
                (mouseleave)="cancelHoverTimer()"
                [ngClass]="{
                  active: activePathByKeyboard.length
                    ? activePathByKeyboard[0] === i0
                    : hoveredActivePath[0] === i0 ||
                      (mainCategoryActiveIndex === i && activePath[0] === i0),
                }"
              >
                <app-link
                  [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + i + '-' + i0"
                  (click)="closeNavigation()"
                  class="main-navigation-link main-navigation-link-lvl-3"
                  [ngClass]="{ 'disabled-link': !subcategory.count }"
                  [link]="subcategory.url"
                >
                  <span>{{ subcategory.name }}</span>

                  <div class="svg-placeholder"></div>

                  @if (subcategory.subcategories?.length) {
                    <app-svg iconName="chevron-right" dimension="1.6rem"></app-svg>
                  }
                </app-link>
              </li>
            </ul>

            <!-- Prefixbox categories level 1 -->
            <ul
              *ngIf="
                category.subcategories[
                  hoveredActivePath[0] >= 0 ? hoveredActivePath[0] : activePath[0]
                ]?.subcategories?.length &&
                (hoveredActivePath[0] !== undefined || activePath[0] !== undefined)
              "
              class="nav-nodes-container lvl-1"
            >
              <a
                [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 1 + '-' + i"
                (click)="closeNavigation()"
                class="show-all-link"
                [routerLink]="
                  category.subcategories[
                    hoveredActivePath[0] >= 0 ? hoveredActivePath[0] : activePath[0]
                  ].url
                "
              >
                {{ 'common.viewAll' | cxTranslate }}
              </a>

              <li
                *ngFor="
                  let subcategory of category.subcategories[
                    hoveredActivePath[0] >= 0 ? hoveredActivePath[0] : activePath[0]
                  ].subcategories;
                  let i1 = index;
                  trackBy: trackByCode
                "
                (mouseenter)="setActive(1, i1)"
                (mouseleave)="cancelHoverTimer()"
                [ngClass]="{
                  active: activePathByKeyboard.length
                    ? activePathByKeyboard[1] === i1
                    : hoveredActivePath[1] === i1 ||
                      (mainCategoryActiveIndex === i && activePath[1] === i1),
                }"
              >
                <app-link
                  [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 1 + '-' + i1"
                  (click)="closeNavigation()"
                  class="main-navigation-link main-navigation-link-lvl-3"
                  [ngClass]="{ 'disabled-link': !subcategory.count }"
                  [link]="subcategory.url"
                >
                  <span>{{ subcategory.name }}</span>

                  <div class="svg-placeholder"></div>

                  @if (subcategory.subcategories?.length) {
                    <app-svg iconName="chevron-right" dimension="1.6rem"></app-svg>
                  }
                </app-link>
              </li>
            </ul>

            <!-- Prefixbox categories level 2 -->
            <ul
              *ngIf="
                category.subcategories[
                  hoveredActivePath[0] >= 0 ? hoveredActivePath[0] : activePath[0]
                ]?.subcategories[hoveredActivePath[1] >= 0 ? hoveredActivePath[1] : activePath[1]]
                  ?.subcategories?.length &&
                (hoveredActivePath[1] !== undefined || activePath[1] !== undefined)
              "
              class="nav-nodes-container lvl-2"
            >
              <a
                [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 2 + '-' + i"
                (click)="closeNavigation()"
                class="show-all-link"
                [routerLink]="
                  category.subcategories[
                    hoveredActivePath[0] >= 0 ? hoveredActivePath[0] : activePath[0]
                  ].subcategories[hoveredActivePath[1] >= 0 ? hoveredActivePath[1] : activePath[1]]
                    .url
                "
              >
                {{ 'common.viewAll' | cxTranslate }}
              </a>

              <li
                *ngFor="
                  let subcategory of category.subcategories[
                    hoveredActivePath[0] >= 0 ? hoveredActivePath[0] : activePath[0]
                  ].subcategories[hoveredActivePath[1] >= 0 ? hoveredActivePath[1] : activePath[1]]
                    .subcategories;
                  let i2 = index;
                  trackBy: trackByCode
                "
                [ngClass]="{
                  active: activePathByKeyboard.length
                    ? activePathByKeyboard[2] === i2
                    : hoveredActivePath[2] === i2 ||
                      (mainCategoryActiveIndex === i && activePath[2] === i2),
                }"
              >
                <app-link
                  [attr.data-qa]="headerNavigationLink?.getButtonId() + '-' + 2 + '-' + i2"
                  (click)="closeNavigation()"
                  class="main-navigation-link main-navigation-link-lvl-3"
                  [ngClass]="{ 'disabled-link': !subcategory.count }"
                  [link]="subcategory.url"
                >
                  <span>{{ subcategory.name }}</span>
                </app-link>
              </li>
            </ul>
          </div>

          <ng-container
            *ngTemplateOutlet="
              nodeImage;
              context: { $implicit: category.categoryNode, onShopFlyout: true }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #nodeImage let-item let-onShopFlyout="onShopFlyout">
  <div class="d-flex flex-row flex-wrap flyout-images">
    @if (
      item?.fields?.cloudinaryImage && item?.fields?.imageLinkUrl && item?.fields?.imageLinkText
    ) {
      <app-link (click)="closeNavigation()" [link]="item.fields.imageLinkUrl" [tabIndex]="1">
        <div class="d-flex flex-column image-container">
          <app-image
            [alt]="item.fields.imageTitle"
            [cloudinaryId]="item.fields.cloudinaryImage"
            [size]="imageSizes.HORIZONTAL_MENU_BANNER"
            class="no-fill"
          ></app-image>
          <div *ngIf="item.fields.imageTitle" class="banner-title">
            {{ item.fields.imageTitle }}
          </div>

          <div class="banner-link">{{ item.fields.imageLinkText }}</div>
        </div>
      </app-link>
    }

    @if (
      item?.fields?.cloudinaryImage2 && item?.fields?.image2LinkUrl && item?.fields?.image2LinkText
    ) {
      <div>
        <app-link (click)="closeNavigation()" [link]="item.fields.image2LinkUrl" [tabIndex]="1">
          <div class="d-flex flex-column image-container">
            <app-image
              [alt]="item.fields.image2Title"
              [cloudinaryId]="item.fields.cloudinaryImage2"
              [size]="imageSizes.HORIZONTAL_MENU_BANNER"
              class="no-fill"
            ></app-image>
            <div *ngIf="item.fields.image2Title" class="banner-title">
              {{ item.fields.image2Title }}
            </div>

            <div class="banner-link">{{ item.fields.image2LinkText }}</div>
          </div>
        </app-link>
        <div style="height: 2.5rem"></div>
      </div>
    }
  </div>
</ng-template>
